import React, { useContext, useCallback } from 'react';
import { SortOrder } from '../../enums';
import { HeadCellType } from '../../interfaces/common';
import { TableContext } from '../../contexts/TableContext';

interface HeadCellProps {
  cell: HeadCellType;
}

const HeadCell: React.FC<HeadCellProps> = ({ cell }) => {
  const { order, orderBy, setOrder, setOrderBy, stickyHeader } = useContext(TableContext);

  const handleHeadCellClick = useCallback(() => {
    let nextSortOrder: SortOrder = SortOrder.asc;
    if (orderBy === cell.id) {
      if (order === SortOrder.asc) nextSortOrder = SortOrder.desc;
      else nextSortOrder = SortOrder.asc;
    }

    setOrder(nextSortOrder);
    setOrderBy(cell.id);
  }, [setOrder, setOrderBy, cell, order, orderBy]);

  return (
    <th
      className={`${cell.sortEnabled ? 'sorting' : 'sorting_disabled'} ${cell.sortEnabled && orderBy === cell.id ? (order === SortOrder.asc ? 'sorting_asc' : 'sorting_desc') : ''}`}
      tabIndex={0}
      rowSpan={1}
      colSpan={1}
      style={{ width: cell.width, textAlign: cell.textAlign, ...(stickyHeader ? { position: 'sticky', top: 0, zIndex: 2, background: 'var(--bs-body-bg, #fff)' } : {}) }}
      onClick={handleHeadCellClick}
    >
      {cell.label}
    </th>
  );
};

export default HeadCell;
